<template>
    <div class="container">
        <div class="row mt-5 mb-5">
            <div class="col-lg-8 col-md-8 col-12 info display-flex">
                <div class="img-user">
                    <!-- :src="!getUserInfo.avatar != null ? cdnUrl + getUserInfo.avatar :thumbUrl('user-avatar.png')" ? -->
                    <img alt="picture"
                        :src="!getUserInfo.avatar || getUserInfo.avatar === null ? imgAvatar : `${uploadUrl}/${getUserInfo.avatar}`"
                        class="img-lg avatar rounded-circle border" />
                </div>
                <div class="info-user margin-left-10">
                    <h3 class="pt-sm-2 pb-1 mb-0 title-color-gray font-sanpro-semibold font-size-24" v-if="getUserInfo">
                        {{ getUserInfo.name }} </h3>
                        <div>
                            Giới tính : {{ getUserInfo.gender ==2?'Nữ':'Nam' }}
                        </div>
                        <div>
                            Id : {{ getUserInfo.userId }}
                        </div>
                        <div>
                           Ngày sinh : {{ moment(getUserInfo.birthday).format('DD/MM/YYYY') }} 
                        </div>
                </div>
            </div>
        </div>
        <div class="">
            <b-tabs class="pre-class-school-list__filter__tabs">
                <b-tab @click="handleChangeTab(tabExcerciseClassSchool)" title="Lịch sử bài tập/ bài kiểm tra" :active="tabActive == tabExcerciseClassSchool">
                    <TabExcerciseClassSchool v-if="tabActive == tabExcerciseClassSchool" :userId="userId" :classSchoolId="classSchoolId" />
                </b-tab>
                <b-tab @click="handleChangeTab(tabElectronicLectures)" title="Lịch sử bài giảng điện tử" :active="tabActive == tabElectronicLectures">
                    <TabElectronicLectures v-if="tabActive == tabElectronicLectures" :userId="userId" :classSchoolId="classSchoolId" />
                </b-tab>
                <b-tab @click="handleChangeTab(tabLessonPlanning)" title="Lịch sử kế hoạch bài dạy" :active="tabActive == tabLessonPlanning">
                    <TabLessonPlanning v-if="tabActive == tabLessonPlanning" :userId="userId" :classSchoolId="classSchoolId" />
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
import { getUserInfoByUserId } from './../_api/index'
const imgAvatar = require('@/assets/images/user-avatar.png');
import TabExcerciseClassSchool from './_component_page_member_personal/TabExcerciseClassSchool.vue'
import TabElectronicLectures from './_component_page_member_personal/TabElectronicLectures.vue'
import TabLessonPlanning from './_component_page_member_personal/TabLessonPlanning.vue'
import moment from "moment";
export default {
    components:{
        TabExcerciseClassSchool,
        TabElectronicLectures,
        TabLessonPlanning
    },
    data() {
        return {
            userId: 0,
            classSchoolId: 0,
            getUserInfo: {},
            imgAvatar,
            tabActive:1,
            tabExcerciseClassSchool : 1,
            tabElectronicLectures : 2,
            tabLessonPlanning : 3,
        }
    },
    mounted() {
        this.userId = this.$route.query.userId
        this.classSchoolId = this.$route.query.classSchoolId
        this.actionGetUserInfo()
    },
    methods: {
        moment,
        handleChangeTab(tab){
            this.tabActive = tab
        },
        actionGetUserInfo() {
            getUserInfoByUserId(this.userId).then((res) => {
                if (res && res.data) {
                    // Save data user profile
                    this.getUserInfo = res.data
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.margin-left-10{
    margin-left: 10px;
}
#main_app {
    padding-bottom: 1rem !important;
}
.pre-class-school-list__filter__tabs {
    height: 56vh;
}
</style>